<script>
    import { gameStarted, paused, country, randomizedCountries, score, timerSeconds, countriesLoaded } from '../stores.js';
    import { countries } from '../laender.json';
    import { knuthShuffle } from 'knuth-shuffle';

    let guessCountry = '';

    let indexes = knuthShuffle([0,1,2,3,4]);

    function clearInput() {
        guessCountry = '';
    }

    function incrementScore() {
        score.update(n => n + 1);
    }
    
    function nextCountry() {
        if ($score <= $randomizedCountries.length) {
            country.set(countries[$randomizedCountries[$score]]);
        }
    }

    function checkGuess() {
        if (!won && $country.name.toLowerCase() === guessCountry.toLowerCase()) {
            clearInput();
            incrementScore();
            nextCountry();
        }
    }

    $: disabled = !$gameStarted || $paused || $score >= $randomizedCountries.length;
    $: won = $randomizedCountries.length > 0 && $score >= $randomizedCountries.length;

    $: if (won) {
        // timerSeconds.set(0);
        paused.set(false);
        gameStarted.set(false);
    }

    $: {
        // console.log(indexes);
        // console.log($randomizedCountries);
        // console.log(countries);
        // console.log(options);
        // console.log(knuthShuffle($randomizedCountries));
    }
</script>

<div class="mui-textfield">
    {#if !won}
        {#if !disabled}
        <div class="mui-select">
            <select bind:value={guessCountry} on:blur={checkGuess} on:change={checkGuess}>
                <option value="">-- Select Country --</option>
                {#each (indexes) as i}
                    <option value={countries[$randomizedCountries[i]].name}>{countries[$randomizedCountries[i]].name}</option>
                {/each}
            </select>
        </div>
        {/if}
        <!-- <input type="text" bind:value={guessCountry} on:input={checkGuess} disabled={disabled}> -->
    {:else}
        <p>You won!</p>
    {/if}
</div>

<style>
    .input {
		padding: 2rem;
		grid-column: 1 / 4;
        display: grid;
        place-items: center;
    }

    .mui-textfield {
        text-align: center;
    }
</style>